// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"984c44c00128903b","5285":"c5dc1c7f4dd05c86"}[chunkId] + ".css";
};